module.exports = __webpack_public_path__ + "img/bg-pattern-bottom-desktop.0616dd81.svg";